// BrainyTots Sticky Add to Cart functionality
document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.querySelector('.bt-sticky-atc-bar');
  if (!stickyBar) return;

  const productInfo = document.querySelector('.product__info-container');
  if (!productInfo) return;

  let isVisible = false;

  function toggleStickyBar() {
    const productInfoBottom = productInfo.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;

    if (productInfoBottom < windowHeight && !isVisible) {
      // Show sticky bar when product info is scrolled out of view
      stickyBar.classList.add('active');
      isVisible = true;

      // Track view event
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'sticky_atc_view',
          product_id: window.productId || '',
          product_name: window.productName || ''
        });
      }
    } else if (productInfoBottom >= windowHeight && isVisible) {
      // Hide sticky bar when product info is back in view
      stickyBar.classList.remove('active');
      isVisible = false;
    }
  }

  // Throttle scroll events for better performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(toggleStickyBar, 10);
  });

  // Track button clicks on sticky bar
  const stickyButton = stickyBar.querySelector('.bt-sticky-atc-button .button');
  if (stickyButton) {
    stickyButton.addEventListener('click', function() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'sticky_atc_click',
          product_id: window.productId || '',
          product_name: window.productName || ''
        });
      }
    });
  }

  // Track prepaid incentive clicks
  const incentiveText = stickyBar.querySelector('.bt-sticky-incentive-text');
  if (incentiveText) {
    incentiveText.addEventListener('click', function() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'prepaid_discount_click',
          location: 'sticky_bar',
          product_id: window.productId || ''
        });
      }
    });
  }
});

// Set global product variables for GA4 tracking
if (typeof product !== 'undefined') {
  window.productId = product.id;
  window.productName = product.title;
}
